import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "cross-circle-18", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 18", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(-3 -3)" },
        React.createElement("circle", { cx: 12, cy: 12, r: 9, fill: "currentColor", fillOpacity: 0.15 }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "m9 9 6 6m0-6-6 6" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
